import NewMessageForm from './NewMessageForm'
import { useGetGroupsQuery } from '../groups/groupsApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import { useParams } from 'react-router-dom'
import { useGetMessagesQuery } from './messageApiSlice'
import { useGetUsersQuery } from '../users/usersApiSlice'

const NewMessage = () => {
    useTitle('geshtop-Exercise: New User')

    const {groupId} = useParams()
    const { groups } = useGetGroupsQuery("groupsList", {
        selectFromResult: ({ data }) => ({
            groups: data?.ids.map(id => data?.entities[id])
        }),
    })
    const { users } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            users: data?.ids.map(id => data?.entities[id])
        }),
    })
   
  
    if (!groups?.length || !users?.length ) return <PulseLoader color={"#FFF"} />
    const filterUsers = groupId==="0" ? [...users] : users.filter(user=>user.groups.includes(groupId))
    //console.log(filterUsers)
    const content = <NewMessageForm groups={groups} usersList={filterUsers} />

    return content
}
export default NewMessage